import { FC, SVGProps } from 'react';

export const CloseIcon2: FC<SVGProps<SVGSVGElement>> = props => (
	<svg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M13.1151 4.19586C13.408 3.90296 13.408 3.42809 13.1151 3.1352C12.8222 2.8423 12.3473 2.8423 12.0544 3.1352L7.9999 7.18973L3.94537 3.1352C3.65248 2.8423 3.1776 2.8423 2.88471 3.1352C2.59182 3.42809 2.59182 3.90296 2.88471 4.19586L6.93924 8.25039L2.88471 12.3049C2.59182 12.5978 2.59182 13.0727 2.88471 13.3656C3.1776 13.6585 3.65248 13.6585 3.94537 13.3656L7.9999 9.31105L12.0544 13.3656C12.3473 13.6585 12.8222 13.6585 13.1151 13.3656C13.408 13.0727 13.408 12.5978 13.1151 12.3049L9.06056 8.25039L13.1151 4.19586Z'
			fill='currentColor'
		/>
	</svg>
);
